import React from "react";
import { Box, IconButton } from "@mui/material";
import { Star, StarBorder, ThumbUp, ThumbDown } from "@mui/icons-material";

const FeedbackSelection = ({ feedbackMethod, rating, thumbs, handleStarClick, handleThumbClick }) => {
    return (
        <React.Fragment>
            {feedbackMethod === "rating" &&
                <Box sx={{ display: 'flex', mt: 1, justifyContent: 'center' }}>
                    {[...Array(5)].map((_, index) => (
                        <IconButton key={index} onClick={() => handleStarClick(index)} sx={{ color: index < rating ? 'rgb(25, 118, 210)' : 'default' }}>
                            {index < rating ? <Star /> : <StarBorder />}
                        </IconButton>
                    ))}
                </Box>
            }
            {feedbackMethod === "thumbs" &&
                <Box sx={{ display: 'flex', mt: 2, justifyContent: 'center' }}>
                    <IconButton onClick={() => handleThumbClick('thumbsup')} sx={{ color: thumbs === 'thumbsup' ? 'rgb(25, 118, 210)' : 'default' }}>
                        <ThumbUp />
                    </IconButton>
                    <IconButton onClick={() => handleThumbClick('thumbsdown')} sx={{ color: thumbs === 'thumbsdown' ? 'rgb(25, 118, 210)' : 'default' }}>
                        <ThumbDown />
                    </IconButton>
                </Box>
            }
        </React.Fragment>
    );
};

export default FeedbackSelection;